import React from 'react';
import { useTranslation } from'react-i18next';
import WelcomeCard from './welcomeCard';
import CheckList from './checkList';
import FeatureAnnouncementCard from './featureAnnouncementCard';
import useTitle from '../comnon/title';

const Dashboard = () => {
    const { t } = useTranslation();
    useTitle(t('home.view_title'));
   return (
       <>
          <FeatureAnnouncementCard />
          <WelcomeCard />
          <CheckList />
       </>

   );

};

export default Dashboard;
